export const MyCircumstances = Object.freeze({
  SINGLE: 'single',
  OTHER: 'other',
});

export const MyCircumstancesDisplay = Object.freeze({
  SINGLE: "It's just me",
  OTHER: 'I have kids and/or a partner',
});